
import {MessageBox,Message} from 'element-ui'
import router from '../router'
function refresh () {
  MessageBox.confirm('检测到最新版本，是否在立即更新？', '确认信息', {
    distinguishCancelAndClose: true,
    confirmButtonText: '立即更新',
    cancelButtonText: '下次更新'
  })
    .then(() => {
     router.go(0)
    })
    .catch(action => {
      Message({
        type: 'info',
        message: action === 'cancel'
          ? '将在下次登录后自动更新'
          : '将在下次登录后自动更新'
      })
    });
}

export {
  refresh
}
